import { render } from "./comparer.vue?vue&type=template&id=81fd9a2e"
import script from "./comparer.vue?vue&type=script&lang=js"
export * from "./comparer.vue?vue&type=script&lang=js"

import exportComponent from "/Users/wojtek/web/customer-zone/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__